import '@babel/polyfill'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import clipboard from 'clipboard'

import App from './App'
import router from '@router'
import i18n from '@lang'
import store from '@state/store'
import '@components/_globals'
import appConfig from '@src/app.config'
import Buefy from 'buefy'

// VCalendar use for booking date-picker
// https://github.com/nathanreyes/v-calendar
import './plugins/fontawesome.js'
import './plugins/element-message-box.js'
import './plugins/element-date-picker.js'
import '@src/design/element-variables.scss'

import VeeValidate, { Validator } from 'vee-validate'
import validateZhTw from 'vee-validate/dist/locale/zh_TW'

// https://www.npmjs.com/package/vue-fb-customer-chat
import VueFbCustomerChat from 'vue-fb-customer-chat'

if(window.globalData.fbPageId) {
  Vue.use(VueFbCustomerChat, {
    // page_id: '1961210497465503',
    page_id: window.globalData.fbPageId,
    theme_color: '#852427',
    locale: 'zh_TW',
  });
}

Vue.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fal',
});

const AppGa = appConfig.ga;
const MerchantGa = window.globalData.ga;

Vue.use(VueAnalytics, {
  id: [AppGa, MerchantGa],
  disableScriptLoader: true,
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
});

Vue.prototype.clipboard = clipboard;

Vue.use(VeeValidate, { events: 'input|blur', inject: false });
Validator.localize('zh_TW', validateZhTw);

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';
// Vue.config.productionTip = true;

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
